import { formatAt, localInputToMs, msToLocalInput, zoneAbbr } from "../../lib/time";
import { useTz } from "../../lib/tz-context";
import { useT } from "../../lib/i18n";

/**
 * 时间输入。**值是 UTC 毫秒，编辑与显示按租户时区。**
 *
 * 用原生 datetime-local：它不带时区语义，正好——我们自己做换算，
 * 不会被浏览器按本地时区二次解释。输入框右边常驻时区缩写，
 * 让人一眼知道自己填的是哪个时区的时间。
 */
export function DateTimeField({
  value, onChange, disabled, className = "",
}: {
  value: number | null;
  onChange: (ms: number | null) => void;
  disabled?: boolean;
  className?: string;
}) {
  const tz = useTz();
  const t = useT();
  const abbr = zoneAbbr(value ?? Date.now(), tz);
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <input
        type="datetime-local"
        value={msToLocalInput(value, tz)}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value ? localInputToMs(e.target.value, tz) : null)}
        className={
          "h-control rounded-base border px-2 text-base outline-none " +
          (disabled ? "cursor-not-allowed border-line bg-fill-light text-ink-disabled" : "border-line bg-white text-ink focus:border-primary")
        }
      />
      <span className="flex-none text-xs text-ink-placeholder" title={t("tz.tip", { tz })}>{abbr}</span>
    </span>
  );
}

/** 只读展示，同样带时区标识 */
export function DateTimeText({ value, withSeconds }: { value: number | null; withSeconds?: boolean }) {
  const tz = useTz();
  return <span className="tabular-nums">{formatAt(value, tz, { withSeconds })}</span>;
}
